<template lang="html">
    <div class="chat-message">
        <div class="message-bubble" :class="position" v-if="typeof message.body === 'string'">
            <div class="message-avatar">
                <img :src="userImageURL" alt="Specialist Image" v-if="userImageURL">
                <img src="@/assets/images/person-icon.png" alt="" v-else>
            </div>
            {{message.body}}
        </div>
        <div class="message-bubble" :class="position" v-else-if="(message.body.type).startsWith('image')">
            <div class="message-avatar">
                <img :src="userImageURL" alt="Specialist Image" v-if="userImageURL">
                <img src="@/assets/images/person-icon.png" alt="" v-else>
            </div>
            <div class="message-image" @click="lastImageUrl = message.body.url; showMediaModal = true">
                <img :src="message.body.url" :alt="message.body.name">
            </div>
        </div>
        <div class="message-bubble" :class="position" v-else-if="(message.body.type).startsWith('video')">
            <div class="message-avatar">
                <img :src="userImageURL" alt="Specialist Image" v-if="userImageURL">
                <img src="@/assets/images/person-icon.png" alt="" v-else>
            </div>
            <div class="message-video">
                <video controls>
                    <source :src="message.body.url" type="video/mp4">
                    Your browser does not support the video tag.
                </video>
            </div>
        </div>
        <div class="message-bubble" :class="position" v-else>
            <div class="message-avatar">
                <img :src="userImageURL" alt="Specialist Image" v-if="userImageURL">
                <img src="@/assets/images/person-icon.png" alt="" v-else>
            </div>
            <a :href="this.message.body.url" target="_blank" class="message-file">                
                <p><i class="fas fa-file"></i> {{message.body.name}}</p>
                <small>• Dimensiune: {{(message.body.size / 1048576).toFixed(2)}} MB</small>
            </a>
        </div>

        <MediaModal v-if="showMediaModal" :imageUrl="lastImageUrl" @toggleMediaModal="showMediaModal = !showMediaModal" mediaType="image"/>
    </div>
</template>

<script>

  import { mapGetters } from 'vuex'
  import config from '@/config';
  import MediaModal from '@/components/ui/MediaModal';

  export default {
    components: {
        MediaModal,
    },
    data(){
        return {
            filestackCDN: config.FILESTACK_CDN,
            showMediaModal: false,
            lastImageUrl: '',
        }
    },
    props: {
        message: {
            type: Object,
            default: function(){
                return {}
            }
        },
        userImageURL: {
            type: String,
            default: ''
        },
        senderRole: {
            type: String,
            default: 'client'
        }
    },
    computed: {
        ...mapGetters({
            user: 'user/user'
        }),
        position: function(){
      
            if(this.user.role == this.senderRole)
                return "right";
            return "left";
        }
    },
    mounted () {
      //Scroll down when user appends new message but do not scroll if scrollDif > 200 and the message is sent by the other user
      var scrollDif = this.$el.parentElement.scrollHeight - this.$el.parentElement.scrollTop - this.$el.parentElement.clientHeight;
      if(this.position == "right")
        this.$el.parentElement.scrollTo(0, this.$el.parentElement.scrollHeight);
      else if(scrollDif < 200)
        this.$el.parentElement.scrollTo(0, this.$el.parentElement.scrollHeight);
    }
}
</script>